import * as React from 'react';
import * as styles from './DateCountdown.scss';
import { differenceInCalendarDays, OwaDate } from 'owa-datetime';
import { getDueDateStyle } from 'owa-timestream-asset-sdk-duedates';
import { Icon } from '@fluentui/react/lib/Icon';
import { observableToday } from 'owa-observable-datetime';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import getPluralizedDayString from 'owa-duration-formatter/lib/lowercase/getPluralizedDayString';

export default observer(function DateCountdown({
    dueDate,
    isCompleted,
}: {
    dueDate: OwaDate;
    isCompleted: boolean;
}) {
    const dueDateStyle = getDueDateStyle(dueDate, isCompleted);
    const overflowClassName = classNames(styles.overflowClip, dueDateStyle);

    const plusSignCutOver = 99;
    const diff = Math.max(0, differenceInCalendarDays(dueDate, observableToday()));
    const count = Math.min(plusSignCutOver, diff);
    const showPlusSign = diff > plusSignCutOver;
    const daysString = getPluralizedDayString(count);

    return (
        <div className={styles.dateCountdown}>
            {isCompleted ? (
                <div className={styles.completed}>
                    <Icon iconName={'CheckMark'} className={styles.checkmark} />
                </div>
            ) : (
                <div className={overflowClassName}>
                    <div className={styles.count}>
                        {count}
                        {showPlusSign && <span className={styles.plusSign}>+</span>}
                    </div>
                    <div className={styles.days}>{daysString}</div>
                </div>
            )}
        </div>
    );
});
